module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('form', {
    attrs: {
      "action": _vm.application_form_url,
      "method": "post",
      "name": "new_application",
      "enctype": "multipart/form-data"
    }
  }, [(_vm.missing_fields.length > 0) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "padding": "5px",
      "color": "red",
      "border": "1px solid red"
    },
    attrs: {
      "id": "error"
    }
  }, [_c('b', [_vm._v("Please answer the following mandatory question(s):")]), _vm._v(" "), _c('ul', _vm._l((_vm.missing_fields), function(error) {
    return _c('li', [_vm._v("\n                    " + _vm._s(error.label) + "\n                ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isApplicationLoaded) ? _c('Application', [_c('div', {
    class: ("" + (_vm.form_width ? _vm.form_width : 'col-md-9')),
    attrs: {
      "id": "tabs"
    }
  }, [_c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "tabs-section",
      "data-tabs": "tabs"
    }
  }, _vm._l((_vm.listVisibleActivities), function(activity, index) {
    return _c('li', {
      staticClass: "nav-item"
    }, [_c('a', {
      class: {
        'nav-link amendment-highlight': _vm.application.has_amendment
      },
      attrs: {
        "data-toggle": "pill"
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(activity)
        }
      }
    }, [_vm._v(_vm._s(activity.label))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._l((_vm.allCurrentActivities), function(activity, index) {
    return _c('div', [_c('AmendmentRequestDetails', {
      attrs: {
        "activity_id": activity.id
      }
    }), _vm._v(" "), (activity.id == _vm.selected_activity_tab_id) ? _c('renderer-block', {
      key: ("renderer_block_" + index),
      attrs: {
        "component": activity
      }
    }) : _vm._e()], 1)
  }), _vm._v("\n                    " + _vm._s(this.$slots.default) + "\n                ")], 2)]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "csrfmiddlewaretoken"
    },
    domProps: {
      "value": _vm.csrf_token
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "schema"
    },
    domProps: {
      "value": JSON.stringify(_vm.application)
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "application_id"
    },
    domProps: {
      "value": 1
    }
  }), _vm._v(" "), (!_vm.application.readonly && _vm.userCanSubmit) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.showCardPayButton || _vm.showCashPayButton) ? _c('span', {
    staticStyle: {
      "margin-right": "5px",
      "font-size": "18px",
      "display": "block"
    }
  }, [_c('strong', [_vm._v("Estimated application fee: " + _vm._s(_vm._f("toCurrency")(_vm.adjusted_application_fee)))]), _vm._v(" "), _c('strong', [_vm._v("Estimated licence fee: " + _vm._s(_vm._f("toCurrency")(_vm.application.licence_fee)))])]) : _vm._e(), _vm._v(" "), (!_vm.isProcessing && _vm.canDiscardActivity) ? _c('input', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "value": "Discard Activity"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardActivity($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isProcessing) ? _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Exit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveExit($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isProcessing) ? _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Continue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSubmitButton),
      expression: "showSubmitButton"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCardPayButton),
      expression: "showCardPayButton"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Pay and Submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pay_and_submit($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCashPayButton),
      expression: "showCashPayButton"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Submit and Record"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit_and_record($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNonePayButton),
      expression: "showNonePayButton"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Migrate"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit_and_record($event)
      }
    }
  }), _vm._v(" "), (_vm.isProcessing) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Processing")]) : _vm._e()])])])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.isProcessing) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Processing")]) : _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'external-applications-dash'
      }
    }
  }, [_vm._v("Back to Dashboard")])], 1)])])])])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13edfe9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/external/application.vue
// module id = 924
// module chunks = 0